
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
// core components
import MaskAndValid from "utils/maskAndValid";
import Bignumber from "./Bignumber";

const useStyles = makeStyles({
  highlight: { color: "#29b6f6", fontSize: "1.6rem" },
});

export default function BignumbersIndicadorConversao({
  periodoLabel,
  resultadoAtual,
  resultadoAnterior,
}) {
  const classes = useStyles();

  return (
    <Grid container>
      <Grid
        item
        xs={12}
        style={{
          padding: "1rem",
          border: "1px solid #f0f0f0",
          margin: "0 15px 15px",
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <Typography
            variant="caption"
            style={{
              color: "#29b6f6",
              textAlign: "center",
              fontSize: "0.8rem",
            }}
          >
            {resultadoAtual.Periodo}&nbsp;
          </Typography>
          <Typography
            variant="caption"
            style={{ textAlign: "center", fontSize: "0.8rem" }}
          >
            &bull;
          </Typography>
          <Typography
            variant="caption"
            style={{ textAlign: "center", fontSize: "0.8rem" }}
          >
            &nbsp;{resultadoAnterior.Periodo}
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Taxa Conversão ${periodoLabel}`}
          value={
            <Box display="flex" alignItems="center">
              <Typography className={classes.highlight}>
                {resultadoAtual.TaxaConversao}%
              </Typography>
              &nbsp;
              <Typography>/ {resultadoAnterior.TaxaConversao}%</Typography>
            </Box>
          }
          icon="far fa-handshake"
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Visitantes ${periodoLabel}`}
          value={
            <Box display="flex" alignItems="center">
              <Typography className={classes.highlight}>
                {resultadoAtual.Visitantes}
              </Typography>
              &nbsp;
              <Typography>
               / {resultadoAnterior.Visitantes}
              </Typography>
            </Box>
          }
          icon={"fas fa-users"}
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Tickets ${periodoLabel}`}
          value={
            <Box display="flex" alignItems="center">
              <Typography className={classes.highlight}>
                {resultadoAtual.Tickets}
              </Typography>
              &nbsp;
              <Typography>
                / {resultadoAnterior.Tickets}
              </Typography>
            </Box>
          }
          icon={"fas fa-ticket-alt"}
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Quantidade de peças ${periodoLabel}`}
          value={
            <Box display="flex" alignItems="center">
              <Typography className={classes.highlight}>
                {resultadoAtual.QtdPecas}
              </Typography>
              &nbsp;
              <Typography>
                / {resultadoAnterior.QtdPecas}
              </Typography>
            </Box>
          }
          icon={"fas fa-boxes"}
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Peças por Atendimento ${periodoLabel}`}
          value={
            <Box display="flex" alignItems="center">
              <Typography className={classes.highlight}>
                {MaskAndValid.maskDecimal(resultadoAtual.PA, 2)}
              </Typography>
              &nbsp;
              <Typography>
                / {MaskAndValid.maskDecimal(resultadoAnterior.PA, 2)}
              </Typography>
            </Box>
          }
          icon={"far fa-list-alt"}
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Ticket Médio ${periodoLabel}`}
          value={
            <Box display="flex" flexDirection="column">
              <Typography className={classes.highlight}>
                {"R$" + MaskAndValid.maskPrice(resultadoAtual.TicketMedio)}
              </Typography>
              <Typography>
                {"/ R$" + MaskAndValid.maskPrice(resultadoAnterior.TicketMedio)}
              </Typography>
            </Box>
          }
          icon={"far fa-clone"}
        />
      </Grid>
      <Grid item xs={12}>
        <Bignumber
          iconPosition="left"
          label={`Faturamento ${periodoLabel}`}
          value={
            <Box display="flex" flexDirection="column">
              <Typography className={classes.highlight}>
                {"R$" + MaskAndValid.maskPrice(resultadoAtual.Faturamento)}
              </Typography>
              <Typography>
                {"/ R$" + MaskAndValid.maskPrice(resultadoAnterior.Faturamento)}
              </Typography>
            </Box>
          }
          icon="far fa-money-bill-alt"
        />
      </Grid>
    </Grid>
  );
}
